import React from 'react';
import {Link} from 'react-router';

export const PreferencesPromptModal = () => {

    // todo if location = pop, show choose prefs, clicking set up prefs will update new endpoint
    // todo show update prefs unless (this will update prefs if im happy is chosen), if last updated is more than 3 months show update prefs,

        return (
            <div className="popup-default">
                <div className="popup-inner">
                    <div className="popup-content">
                        <h3 className="h3">Choose your privacy preferences</h3>
                        <p className="p-tag">Maintaining the privacy and data security of our users is just as much a priority for us as it is for you. To help us to best do this, please take a moment to inform us of your preferences.</p>
                        <ul className="buttons-left">
                            <li>
                                <Link to={`/account/preferences`}
                                    className="btn btn-primary--ghost">
                                    <span className="label">Set up Preferences</span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        )
};




// WEBPACK FOOTER //
// src/client/components/common/elements/PreferencesPromptModal.js